import type { SVGProps } from 'react'

export const LUMO_PAW_CREAM = '#F5E7C6'
export const LUMO_AUBERGINE = '#310A1E'

type LumoPawProps = SVGProps<SVGSVGElement> & {
  title?: string
  pawFill?: string
}

export function LumoPaw({
  className = '',
  title = 'Lumo',
  pawFill = LUMO_PAW_CREAM,
  ...props
}: LumoPawProps) {
  return (
    <svg
      {...props}
      className={className}
      viewBox="0 0 136 164"
      fill="none"
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? props['aria-hidden'] : true}
    >
      <path
        d="M16.0364 100.961C34.875 126.36 28.3676 141.581 28.9544 159.571L122.904 156.507C138.597 85.4576 131.493 21.0436 112.416 18.2753C101.157 16.6414 95.8583 32.8228 94.571 39.3682C93.7615 29.8895 88.4001 3.55031 74.4306 4.00592C60.9378 4.44599 57.6666 27.5649 58.5901 40.5417C56.535 33.7718 40.8412 17.8582 31.4685 21.9159C12.7231 30.0313 30.3365 72.4797 33.2777 77.3864C29.386 74.0115 12.6213 64.3686 6.69362 71.908C0.765897 79.4473 4.95132 86.0153 16.0364 100.961Z"
        fill={pawFill}
        stroke={LUMO_AUBERGINE}
        strokeWidth="8"
      />
      <ellipse cx="39.5517" cy="42.5456" rx="6.38157" ry="8.77466" transform="rotate(-21.0206 39.5517 42.5456)" fill={LUMO_AUBERGINE} />
      <ellipse cx="74.4669" cy="24.7909" rx="6.38157" ry="8.77466" transform="rotate(-1.86802 74.4669 24.7909)" fill={LUMO_AUBERGINE} />
      <ellipse cx="110.114" cy="38.4548" rx="6.38157" ry="8.77466" transform="rotate(6.31278 110.114 38.4548)" fill={LUMO_AUBERGINE} />
      <path
        d="M46.755 68.5577L56.0353 60.6934C67.0549 51.3553 82.8418 50.1967 95.1067 57.826L102.985 62.7267C108.839 66.3683 112.138 73.0015 111.508 79.8671C110.668 89.0222 103.141 96.1185 93.9528 96.4182L57.943 97.5926C50.9896 97.8194 44.6432 93.6538 42.0852 87.184C39.4884 80.6161 41.3668 73.1237 46.755 68.5577Z"
        fill={LUMO_AUBERGINE}
      />
    </svg>
  )
}
